import { OverlayRef } from '@angular/cdk/overlay';

export class O2TourRef {
  constructor(private readonly overlay: OverlayRef) { }

  close() {
    this.overlay.dispose();
  }

  isVisible() {
    return this.overlay && this.overlay.overlayElement;
  }

  getPosition() {
    return this.overlay.overlayElement.getBoundingClientRect()
  }
}



// WEBPACK FOOTER //
// ./src/app/o2-tour/o2-tour-ref.ts